<template>
  <v-app id="app">
    <v-main :class="$vuetify.breakpoint.xs ? 'pa-0' : ''">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // https://stackoverflow.com/a/50683190/1415058
    const appHeight = () => {
      const doc = document.documentElement;
      doc.style.setProperty('--app-height', `${window.innerHeight}px`);
    };
    window.addEventListener('resize', appHeight);
    appHeight();
  },
};
</script>

<style lang="scss">
  :root {
    --app-height: 100vh;
  }

  html,
  body {
      padding: 0;
      margin: 0;
      overflow: hidden !important;
      width: 100vw;
      height: 100vh;
      @media not all and (hover:hover) {
          height: var(--app-height);
      }
  }
</style>
